import { cn } from 'lib/utils'
import * as React from 'react'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 font-inter text-p-400 tracking-normal shadow-none placeholder:text-muted-foreground focus-visible disabled:cursor-not-allowed disabled:opacity-50',
        props.disabled && 'bg-muted',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'

export { Textarea }
